import { MedicalType } from "@qendo/medical/types";
import { useLocalSearchParams } from "expo-router";
import { PastSymptomForm } from "~/components/form/health-profile/PastSymptomForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useMedical } from "~/providers/MedicalProvider";

const type = MedicalType.past_symptom;

export default function EditPastSymptom() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { handleDismiss } = useDismiss();
    const symptom = findMedical(type, id);

    if (!symptom) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="past_symptoms">
            <PastSymptomForm symptom={symptom} onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
